import styled from 'styled-components';

import { H1 } from '@ad-scripts/presentation/components/common/headers';
import { Row } from 'src/presentation/components/forms/Layout';

export const CampaignSectionRow = styled(Row)`
  margin-bottom: 0;
  align-items: center;
`;

export const CampaignDetails = styled.div`
  background-color: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray300};
  padding: 8px;
  border-radius: 4px;
  width: 100%;
  min-height: 100px;
`;

export const FormHeader = styled(H1)`
  padding-bottom: 42px;
  margin-bottom: 0;
`;
